"use strict";
import React from "react";

const TableRow = (props) => {
    const { filaEnModoDesplegable, mostrarFilaEnModoDesplegable, parametro, entidadInstanciaId, isWhiteRow, tooltip } = props;
    let classModoDesplegableFila = filaEnModoDesplegable ? "table-tr-grey-light" : "table-tr-white";
    let classModoDesplegableLabel = filaEnModoDesplegable ? "label-orange-14-bold" : "label-grey-dark-14";
    let classModoDesplegableLink = filaEnModoDesplegable ? "clickable none-text-decoration ti-angle-up orange" : "clickable none-text-decoration ti-angle-down grey-dark";
    const classIconoInactivo = "atlas_seccionGrilla__registroIconoInactivo";
    const classRegistro = "atlas_seccionGrilla__registroIconoInactivo";

    let parametroRow = parametro.filter(instancia => instancia.VISIBLEENGRILLAENTIDAD);

    // Verificar si al menos una instancia está inactiva
    const isInactive = parametroRow.some(instancia => !instancia.Activo);

    return (
        <tr className={`${classModoDesplegableFila} ${isWhiteRow ? 'table-tr-white' : 'table-tr-grey-light'}`} onClick={() => { mostrarFilaEnModoDesplegable(entidadInstanciaId, filaEnModoDesplegable) }}>
            {parametroRow.map(instancia => (
                <td key={instancia.Id} onClick={(e) => e.stopPropagation()}>
                    <label className={classModoDesplegableLabel}>{instancia.Valor}</label>
                </td>
            ))}
            <td colSpan={"2"} className={"atlas_Modo_Desplegable_Link"}>
                <div className="text-right">
                    <a className={classModoDesplegableLink}></a>
                    {isInactive && (
                        <span className={`${filaEnModoDesplegable ? 'atlas_seccionGrilla__registroIconoInactivo_desplegable' : ''} ${classIconoInactivo} mover-izquierda ${classRegistro}`} title={tooltip} data-toggle="tooltip" data-placement="left"></span>
                    )}
                </div>
            </td>
        </tr>
    );
}

export default TableRow;

/*mostrarFilaModoDesplegable*/